/**
 * Global audio manager: ensures only one TTS/audio playback runs at a time.
 * Stops any previous Web Audio or native/Web Speech playback before starting a new one.
 */
import { stopNativeTTS } from './nativeTts';

let currentAudio = null; // { source, ctx, onEnd }

export function stopAllAudio() {
  if (currentAudio) {
    const { source, ctx, onEnd } = currentAudio;
    try {
      source.onended = null;
      source.stop(0);
    } catch (e) {
      // ignore
    }
    try {
      ctx.close();
    } catch (e) {
      // ignore
    }
    currentAudio = null;
    onEnd?.();
  }
  stopNativeTTS();
}

export function playAudioBlob(blob, { onStart, onEnd } = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) throw new Error('Web Audio API not supported');

      // Stop any currently playing audio before starting a new one.
      stopAllAudio();

      const ctx = new AC();

      if (ctx.state === 'suspended') {
        await ctx.resume();
      }

      const arrayBuffer = await blob.arrayBuffer();
      const audioBuffer = await ctx.decodeAudioData(arrayBuffer);

      const source = ctx.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(ctx.destination);

      source.onended = () => {
        if (currentAudio?.source === source) {
          currentAudio = null;
        }
        onEnd?.();
        ctx.close().catch(() => {});
        resolve();
      };

      currentAudio = { source, ctx, onEnd };
      onStart?.();
      source.start(0);
    } catch (err) {
      stopAllAudio();
      onEnd?.();
      reject(err);
    }
  });
}
